import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const BottleMilk = memo((props: IconProps) => {
    const { color = "#0E0E0E", ...rest } = props
    return (
        <svg width="1em" height="1em" viewBox="0 0 9 16" fill="none" {...rest}>
            <path
                fill={color}
                fillRule="evenodd"
                d="M7.137 15.984H1.885c-1.013 0-1.837-.747-1.837-1.666V7.022c0-.42.444-1.397 1.173-2.956.422-.898.996-2.127 1.002-2.375 0-.124-.209-.352-.35-.503C1.635.93 1.39.664 1.543.36c.148-.294.554-.335.974-.335H6.5c.53.004.91.066 1.053.354.148.305-.107.577-.332.818-.139.147-.348.369-.348.493.002.25.562 1.494.975 2.4.701 1.546 1.126 2.515 1.126 2.93v7.297c0 .92-.826 1.667-1.837 1.667ZM2.543 1.04c.22.242.453.585.453.939 0 .347-.324 1.113-.965 2.506-.449.97-1.059 2.299-1.059 2.6v7.043c0 .533.475.966 1.055.966H6.99c.584 0 1.058-.433 1.058-.966V7.086c0-.301-.587-1.62-1.018-2.58-.604-1.361-1.01-2.181-1.01-2.531 0-.354.3-.681.522-.921l.008-.01c.016-.018-.076-.067-.167-.067H2.627c-.053 0-.1.044-.084.064Z"
                clipRule="evenodd"
            />
            <path
                fill={color}
                d="M2.543 1.04c.22.243.453.586.453.94 0 .347-.324 1.113-.965 2.506-.449.97-1.059 2.299-1.059 2.6v7.043c0 .533.475.966 1.055.966H6.99c.584 0 1.058-.433 1.058-.966V7.086c0-.301-.587-1.62-1.018-2.58-.604-1.361-1.01-2.181-1.01-2.531 0-.354.3-.681.522-.921l.008-.01c.016-.018-.076-.067-.167-.067H2.627c-.053 0-.1.044-.084.064Z"
            />
            <path
                fill="#fff"
                d="M5.799 13.979c.643 0 1.164-.186 1.164-.887V6.538c0-.701-1.55-.582-2.906.474-1.355 1.06-1.985-1.175-1.985-.474v6.554c0 .7.52.887 1.163.887h2.564Z"
            />
        </svg>
    )
})

export default BottleMilk
